import { Toggle, type ToggleProps } from "components/ui/Toggle";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  useController,
} from "react-hook-form";

export type RhfToggleProps<T extends FieldValues> = {
  name: FieldPath<T>;
  control?: Control<T>;
} & Omit<ToggleProps, "checked" | "onChange" | "onBlur" | "name">;

/**
 * React Hook Form アダプタ for Toggle (boolean field)。
 * @param {RhfToggleProps<T>} props RhfToggle の props
 * @return {JSX.Element} RHF と接続された Toggle
 */
export function RhfToggle<T extends FieldValues>({
  name,
  control,
  ...toggleProps
}: RhfToggleProps<T>): JSX.Element {
  const { field } = useController<T>({ name, control });

  return (
    <Toggle
      {...toggleProps}
      name={field.name}
      checked={Boolean(field.value)}
      onChange={field.onChange}
      onBlur={field.onBlur}
      ref={field.ref}
    />
  );
}
